import Vue from 'vue'
import { Context } from '@nuxt/types'
import screenResolution from '~/lib/screen-resolution'
import { getKeys } from '~/lib/utils/utils'

interface VP {
  resolution: number;
  xs: boolean;
  s: boolean;
  m: boolean;
  l: boolean;
  xl: boolean;
  xxl: boolean;
}

declare module 'vue/types/vue' {
  interface Vue {
    $vp: VP
  }
}

interface Result {
  viewportWidth: number;
  breakpointNames: string[];
}

export default (context: Context) => {
  const initVal = {
    resolution: 0,
    xs: false,
    s: false,
    m: false,
    l: false,
    xl: false,
    xxl: false
  }

  Vue.prototype.$vp = Vue.observable(initVal)

  screenResolution.subscribe((screen: Result) => {
    context.$accessor.screen.setScreenResolution(screen)

    getKeys(initVal).forEach(propName => (Vue.prototype.$vp[propName] = context.$accessor.screen[propName]))
  })
}
